export function makePointFeature<TData>(
  coordinates: GeoJSON.Position,
  data: TData
): GeoJSON.Feature<GeoJSON.Point, { data: TData }> {
  return {
    type: 'Feature',
    properties: {
      data
    },
    geometry: {
      type: 'Point',
      coordinates
    }
  };
}
